export class LocationSnapshotFilters
{
    countryIDs: string[];
    siteIDs: number[];
    globalIndustrySegmentIDs: number[];
    radiusAroundEachPlant: number = 200;
    includeSuspectList: boolean;
    removeExcluded: boolean;
    crossCountryBorders: boolean;
    limitToSiteRevenueGrtThan1MM: boolean;
    showDistanceRings: boolean;
    includeSAPCustomerList: boolean;
    plantCompany: string;
    trailerSize: number;
    distributionCost: number;
    siteNames: string;
    globalSegments: string;
    product: string[];
}
